import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../configs/client";

export const getCountries = createAsyncThunk(
  "countries/get",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await client.get(`/countries`);
      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const countrySlice = createSlice({
  name: "countries",
  initialState: {
    isLoading: false,
    error: null,
    countries: [],
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getCountries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCountries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.countries = action?.payload?.result;
      })
      .addCase(getCountries.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default countrySlice.reducer;
